// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"GX-z","inlineTitle":"HX-z","sponsoredAdsWrapper":"IX-z","marketplaceRecosWrapper":"JX-z"};